import React from 'react'
import { SvgIcon } from '@material-ui/core'

const CookieIcon = ({
  fill = '#FFFFFF',
  width = '24px',
  height = '24px',
  className,
  ...rest
}) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      width={width}
      height={height}
      className={className}
      {...rest}
    >
      <path d="M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a1 1 0 0 0-1.197-1.015 2.93 2.93 0 0 1-.605.064C13.556 6.942 12 5.386 12 3.456c0-.068.01-.136.015-.204a1 1 0 0 0-1.17-1.06C5.99 3.07 2 7.456 2 12.756c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.169-.01-.336-.023-.502a1.004 1.004 0 0 0-.379-.19zM12 20.756c-4.411 0-8-3.589-8-8 0-3.721 2.474-6.936 6.003-7.85.404 2.105 2.194 3.76 4.399 3.996C14.741 10.511 16 11.947 16 13.643c0 .072.012.14.019.21a4.003 4.003 0 0 0 3.67 3.645 8.006 8.006 0 0 1-7.689 3.258zM9 13.756a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    </SvgIcon>
  )
}

export default CookieIcon
